import Profile from '@/components/Personal/Profile'
import ProfileAddresses from '@/components/Personal/ProfileAddresses'
import ProfileOrderHistory from '@/components/Personal/ProfileOrderHistory'
import ProfileEdit from '@/components/Personal/ProfileEdit'
import ProfileChangePassword from '@/components/Personal/ProfileChangePassword'
import ProfileAddress from '@/components/Personal/ProfileAddress'
import ProfileOrderHistoryDetail from '@/components/Personal/ProfileOrderHistoryDetail'

export default [
    {
        path: '/personal/',
        name: 'profile',
        component: Profile,
        meta: {
            title: 'Личный кабинет',
        },
    },
    {
        path: '/personal/edit-profile/',
        name: 'profile-edit',
        component: ProfileEdit,
        meta: {
            title: 'Редактирование профиля',
        },
    },
    {
        path: '/personal/change-password/',
        name: 'profile-change-password',
        component: ProfileChangePassword,
        meta: {
            title: 'Изменить пароль',
        },
    },
    {
        path: '/personal/addresses/',
        name: 'delivery-address',
        component: ProfileAddresses,
        meta: {
            title: 'Адреса доставки',
        },
    },
    {
        path: '/personal/addresses/edit/:addressId?',
        name: 'delivery-address-create',
        component: ProfileAddress,
        props: true,
        meta: {
            title: 'Адреса доставки - Редактирование',
        },
    },
    {
        path: '/personal/order-history/',
        name: 'order-history',
        component: ProfileOrderHistory,
        meta: {
            title: 'История заказов',
        },
    },
    {
        path: '/personal/order-history-detail/:orderId',
        name: 'order-history-detail',
        component: ProfileOrderHistoryDetail,
        props: true,
        meta: {
            title: 'История заказов',
        },
    },
];